import React, { useEffect, useState } from "react"
import { useOutletContext, useParams } from "react-router-dom"
import axios from "axios"
import { FaPlus, FaSave, FaTrash, FaExternalLinkAlt, FaCalendarAlt } from "react-icons/fa"

export default function CircuitoEtapasPainel() {
  const { slug } = useParams()
  const { circuito } = useOutletContext()
  const circuitoId = circuito?._id

  const [eventosInternos, setEventosInternos] = useState([])
  const [etapasManuais, setEtapasManuais] = useState([])
  const [loading, setLoading] = useState(false)

  // form
  const [nome, setNome] = useState("")
  const [linkExterno, setLinkExterno] = useState("")
  const [dataInicioVendas, setDataInicioVendas] = useState("")
  const [dataFimVendas, setDataFimVendas] = useState("")
  const [dataEvento, setDataEvento] = useState("")
  const [imagemCartaz, setImagemCartaz] = useState(null)

  const carregarEventosInternos = async () => {
    try {
      const res = await axios.get(`https://api.ticketdovaqueiro.com/api/circuitos/slug/${slug}`)
      setEventosInternos(res.data?.eventos || [])
    } catch (e) {
      console.error("Erro ao carregar eventos internos:", e)
      setEventosInternos([])
    }
  }

  const carregarEtapasManuais = async () => {
    try {
      const res = await axios.get(
        `https://api.ticketdovaqueiro.com/api/circuitos/${circuitoId}/etapas-manuais`
      )
      setEtapasManuais(res.data || [])
    } catch (e) {
      console.error("Erro ao carregar etapas manuais:", e)
      setEtapasManuais([])
    }
  }

  useEffect(() => {
    if (slug) carregarEventosInternos()
  }, [slug])

  useEffect(() => {
    if (circuitoId) carregarEtapasManuais()
  }, [circuitoId])

  const criarEtapaManual = async () => {
    try {
      if (!nome || !linkExterno || !dataInicioVendas || !dataFimVendas || !dataEvento) {
        return alert("Preencha todos os campos obrigatórios.")
      }

      setLoading(true)

      const form = new FormData()
      form.append("nome", nome)
      form.append("linkExterno", linkExterno)
      form.append("dataInicioVendas", dataInicioVendas)
      form.append("dataFimVendas", dataFimVendas)
      form.append("dataEvento", dataEvento)

      if (imagemCartaz) form.append("imagemCartaz", imagemCartaz)

      await axios.post(
        `https://api.ticketdovaqueiro.com/api/circuitos/${circuitoId}/etapas-manuais`,
        form
      )

      alert("Etapa manual criada ✅")

      setNome("")
      setLinkExterno("")
      setDataInicioVendas("")
      setDataFimVendas("")
      setDataEvento("")
      setImagemCartaz(null)

      carregarEtapasManuais()
    } catch (e) {
      console.error(e)
      alert("Erro ao criar etapa manual")
    } finally {
      setLoading(false)
    }
  }

  const deletarEtapa = async (id) => {
    if (!window.confirm("Excluir essa etapa manual?")) return
    try {
      await axios.delete(
        `https://api.ticketdovaqueiro.com/api/circuitos/${circuitoId}/etapas-manuais/${id}`
      )
      carregarEtapasManuais()
    } catch (e) {
      console.error(e)
      alert("Erro ao excluir etapa")
    }
  }

  return (
    <div>
      {/* Header */}
      <div className="pc-page-header">
        <h1 className="pc-page-header__title">
          <FaCalendarAlt style={{ marginRight: 12, color: "var(--pc-accent)" }} />
          Etapas
        </h1>
        <p className="pc-page-header__subtitle">
          Gerencie etapas internas e etapas externas do circuito {circuito?.nome}
        </p>
      </div>

      {/* Etapas internas */}
      <div className="pc-card">
        <div className="pc-card__header">
          <h3 className="pc-card__title">Etapas internas (Ticket do Vaqueiro)</h3>
        </div>

        {eventosInternos.length === 0 ? (
          <div className="pc-empty">Nenhum evento interno associado ao circuito.</div>
        ) : (
          <div className="pc-list">
            {eventosInternos.map((ev) => (
              <div key={ev._id} className="pc-list-item">
                <div className="pc-list-item__content">
                  <h4 className="pc-list-item__title">{ev.nome}</h4>
                  <p className="pc-list-item__subtitle">
                    Etapa integrada ao Ticket do Vaqueiro (compra dentro do sistema)
                  </p>
                </div>

                <div className="pc-list-item__actions">
                  <span
                    className="pc-badge"
                    style={{
                      background: "rgba(16,185,129,0.15)",
                      border: "1px solid rgba(16,185,129,0.25)",
                      color: "#10b981",
                      padding: "8px 10px",
                      borderRadius: 999,
                      fontWeight: 900,
                      fontSize: 12,
                    }}
                  >
                    INTERNA
                  </span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Criar etapa manual */}
      <div className="pc-card">
        <div className="pc-card__header">
          <h3 className="pc-card__title">
            <FaPlus style={{ marginRight: 10 }} />
            Cadastrar etapa manual (venda externa)
          </h3>
        </div>

        <div className="pc-form-row">
          <div className="pc-form-group">
            <label className="pc-label">Nome *</label>
            <input
              className="pc-input"
              value={nome}
              onChange={(e) => setNome(e.target.value)}
              placeholder="Nome da etapa/evento"
            />
          </div>

          <div className="pc-form-group">
            <label className="pc-label">Link externo *</label>
            <input
              className="pc-input"
              value={linkExterno}
              onChange={(e) => setLinkExterno(e.target.value)}
              placeholder="https://..."
            />
          </div>
        </div>

        <div className="pc-form-row">
          <div className="pc-form-group">
            <label className="pc-label">Início das vendas *</label>
            <input
              type="date"
              className="pc-input"
              value={dataInicioVendas}
              onChange={(e) => setDataInicioVendas(e.target.value)}
            />
          </div>

          <div className="pc-form-group">
            <label className="pc-label">Fim das vendas *</label>
            <input
              type="date"
              className="pc-input"
              value={dataFimVendas}
              onChange={(e) => setDataFimVendas(e.target.value)}
            />
          </div>

          <div className="pc-form-group">
            <label className="pc-label">Data do evento *</label>
            <input
              type="date"
              className="pc-input"
              value={dataEvento}
              onChange={(e) => setDataEvento(e.target.value)}
            />
          </div>
        </div>

        <div className="pc-form-group">
          <label className="pc-label">Cartaz</label>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => setImagemCartaz(e.target.files[0])}
            className="pc-file-input"
          />
        </div>

        <button
          onClick={criarEtapaManual}
          disabled={loading}
          className="pc-btn pc-btn--primary"
        >
          <FaSave />
          {loading ? "Salvando..." : "Cadastrar etapa"}
        </button>
      </div>

      {/* Etapas manuais */}
      <div className="pc-card">
        <div className="pc-card__header">
          <h3 className="pc-card__title">Etapas manuais cadastradas</h3>
        </div>

        {etapasManuais.length === 0 ? (
          <div className="pc-empty">Nenhuma etapa manual cadastrada.</div>
        ) : (
          <div className="pc-list">
            {etapasManuais.map((e) => (
              <div key={e._id} className="pc-list-item">
                <div className="pc-list-item__content">
                  <h4 className="pc-list-item__title">{e.nome}</h4>

                  <p className="pc-list-item__subtitle">
                    Venda externa •{" "}
                    <a
                      href={e.linkExterno}
                      target="_blank"
                      rel="noreferrer"
                      style={{ color: "var(--pc-accent)", fontWeight: 900, textDecoration: "none" }}
                    >
                      Abrir link <FaExternalLinkAlt style={{ marginLeft: 6, fontSize: 12 }} />
                    </a>
                  </p>
                </div>

                <div className="pc-list-item__actions">
                  <button
                    onClick={() => deletarEtapa(e._id)}
                    className="pc-btn pc-btn--danger pc-btn--sm"
                  >
                    <FaTrash />
                    Excluir
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
